import React from 'react';
import 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/* add css styles here (optional) */\n\n.visuallyhidden {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.full-symbol {\n  display: none;\n}\n.accessible-rating input.selected + label .full-symbol,\n.accessible-rating input:checked + label .full-symbol {\n  display: inline-block;\n}\n.accessible-rating input.selected + label .empty-symbol,\n.accessible-rating input:checked + label .empty-symbol {\n  display: none;\n}\n.accessible-rating input:focus + label {\n  border-bottom-style: dotted;\n}\n";
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var DefaultEmptySymbol = function DefaultEmptySymbol() {
  return React.createElement(
    'svg',
    { viewBox: '0 0 512 512', width: '33px', height: '33px' },
    React.createElement('path', {
      fill: '#858585',
      d: 'M512 198.525l-176.89-25.704-79.11-160.291-79.108 160.291-176.892 25.704 128 124.769-30.216 176.176 158.216-83.179 158.216 83.179-30.217-176.176 128.001-124.769z'
    })
  );
};

var DefaultFullSymbol = function DefaultFullSymbol() {
  return React.createElement(
    'svg',
    { viewBox: '0 0 512 512', width: '33px', height: '33px' },
    React.createElement('path', {
      fill: '#036',
      d: 'M512 198.525l-176.89-25.704-79.11-160.291-79.108 160.291-176.892 25.704 128 124.769-30.216 176.176 158.216-83.179 158.216 83.179-30.217-176.176 128.001-124.769z'
    })
  );
};

var Star = React.memo(function (_ref) {
  var emptySymbol = _ref.emptySymbol,
      fullSymbol = _ref.fullSymbol,
      index = _ref.index,
      changeHandler = _ref.changeHandler,
      initialRating = _ref.initialRating,
      noOfSelectedSymbols = _ref.noOfSelectedSymbols,
      getRatingValue = _ref.getRatingValue;
  return React.createElement(
    React.Fragment,
    null,
    React.createElement('input', {
      value: index,
      id: 'star' + index,
      type: 'radio',
      name: 'rating',
      onChange: function onChange() {
        changeHandler(index);
        getRatingValue(index);
      },
      checked: initialRating === index || index === noOfSelectedSymbols,
      className: 'visuallyhidden ' + (index <= noOfSelectedSymbols ? 'selected' : '')
    }),
    React.createElement(
      'label',
      {
        htmlFor: 'star' + index,
        onMouseEnter: function onMouseEnter() {
          changeHandler(index);
          getRatingValue(index);
        },
        onTouchStart: function onTouchStart() {
          changeHandler(index);
          getRatingValue(index);
        }
      },
      React.createElement(
        'span',
        { className: 'visuallyhidden' },
        index + ' Star' + (index === 1 ? '' : 's')
      ),
      React.createElement(
        'span',
        { className: 'empty-symbol' },
        emptySymbol
      ),
      React.createElement(
        'span',
        { className: 'full-symbol' },
        fullSymbol
      )
    )
  );
});

var Rating = function (_React$PureComponent) {
  inherits(Rating, _React$PureComponent);

  function Rating() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Rating);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Rating.__proto__ || Object.getPrototypeOf(Rating)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      noOfSelectedSymbols: 0
    }, _this.changeHandler = function (noOfSelectedSymbols) {
      return _this.setState({ noOfSelectedSymbols: noOfSelectedSymbols });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Rating, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$emptySymbol = _props.emptySymbol,
          emptySymbol = _props$emptySymbol === undefined ? React.createElement(DefaultEmptySymbol, null) : _props$emptySymbol,
          _props$fullSymbol = _props.fullSymbol,
          fullSymbol = _props$fullSymbol === undefined ? React.createElement(DefaultFullSymbol, null) : _props$fullSymbol,
          _props$numberOfRating = _props.numberOfRatings,
          numberOfRatings = _props$numberOfRating === undefined ? 5 : _props$numberOfRating,
          _props$initialRating = _props.initialRating,
          initialRating = _props$initialRating === undefined ? 0 : _props$initialRating,
          _props$getRatingValue = _props.getRatingValue,
          getRatingValue = _props$getRatingValue === undefined ? function () {} : _props$getRatingValue,
          _props$legend = _props.legend,
          legend = _props$legend === undefined ? 'your ratings' : _props$legend;

      return React.createElement(
        'fieldset',
        { className: 'accessible-rating' },
        React.createElement(
          'legend',
          null,
          legend
        ),
        [].concat(toConsumableArray(new Array(numberOfRatings))).map(function (item, index) {
          return React.createElement(Star, {
            emptySymbol: emptySymbol,
            fullSymbol: fullSymbol,
            index: index + 1,
            key: index,
            changeHandler: _this2.changeHandler,
            initialRating: initialRating,
            getRatingValue: getRatingValue,
            noOfSelectedSymbols: _this2.state.noOfSelectedSymbols
          });
        })
      );
    }
  }]);
  return Rating;
}(React.PureComponent);

export default Rating;



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0